import React from 'react';

import { ArrowLeft, ArrowRight } from '@gravity-ui/icons';
import { Button, Flex, Icon } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';

interface Props {
    goPrevRange: () => void;
    goNextRange: () => void;
    initRanges: () => void;
    hasPrevRange?: boolean;
    hasNextRange?: boolean;
}

const t = i18n(keyset);

export const AliceAppMonitoringPageHistoryControls: React.FC<Props> = ({
    goPrevRange,
    goNextRange,
    initRanges,
    hasPrevRange,
    hasNextRange,
}) => {
    return (
        <Flex gap={2}>
            <span>
                <Button onClick={() => goPrevRange()} disabled={!hasPrevRange}>
                    <Icon data={ArrowLeft} />
                </Button>
            </span>
            <span>
                <Button onClick={() => goNextRange()} disabled={!hasNextRange}>
                    <Icon data={ArrowRight} />
                </Button>
            </span>
            <span>
                <Button onClick={() => initRanges()}>{t('reset-zoom')}</Button>
            </span>
        </Flex>
    );
};
